import axios from 'axios';
import config from '../config';

const api = axios.create({
    withCredentials: true,
});

// Idle timer reset callback — set by UserContext
let _onApiActivity = null;
export function setOnApiActivity(callback) {
    _onApiActivity = callback;
}

// Request interceptor to set base URL and reset idle timer
api.interceptors.request.use((reqConfig) => {
    // Set base URL if path is relative
    if (reqConfig.url && !reqConfig.url.startsWith('http')) {
        reqConfig.url = config.API_SERVER + reqConfig.url;
    }
    if (_onApiActivity) _onApiActivity();
    return reqConfig;
});

// Response interceptor to handle auth errors
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // On 401, try to refresh the session once
        if (error.response?.status === 401 && !originalRequest._retried) {
            originalRequest._retried = true;
            try {
                const refreshResponse = await axios.post(
                    config.API_SERVER + 'auth/refresh-session',
                    {},
                    { withCredentials: true }
                );
                if (refreshResponse.status === 200) {
                    // Retry the original request with the new cookie
                    return api(originalRequest);
                }
            } catch (refreshError) {
                // Refresh failed — redirect to login
            }
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default api;
